angular.module('octopusApp.projects')
    .controller('VariablePromptSettingsController', function(prompt, $scope, $uibModalInstance) {

        $scope.prompt = prompt;

        $scope.cancel = $uibModalInstance.close;

        $scope.save = function() {
            $uibModalInstance.close($scope.prompt);
        };

        $scope.delete = function() {
            $uibModalInstance.close(null);
        };
    });



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/variable_prompt_settings.js
// module id = 1798741170183088
// module chunks = 1